import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { CertificatesService } from 'services/professional/certificates/certificates.service';
import { Observable } from 'rxjs';

export interface EducationStepNotification {
  id: number;
  name: string;
  statusColorId: number;
}

export const professionalStepNotificationsResolver: ResolveFn<Observable<any>> = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
) => {
  return inject(CertificatesService).getNotifications();
};
